import { FC } from 'react';

export const RightIcon: FC = () => (
    <svg
        width="20px"
        height="20px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        style={{ transform: 'translateX(3px)' }}
    >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="故障信息" transform="translate(-1144.000000, -136.000000)" stroke="#000000" strokeWidth="1.5">
                <g id="-mockplus-" transform="translate(740.000000, 128.000000)">
                    <g id="-mockplus-" transform="translate(404.000000, 8.000000)">
                        <g id="01icon/system/date" transform="translate(4.000000, 3.500000)">
                            <rect id="Rectangle" strokeOpacity="0.8" x="0.75" y="2.25" width="14.5" height="13.5" rx="2"></rect>
                            <line x1="4" y1="-1.38777878e-16" x2="4" y2="4.5" id="Path-17" strokeOpacity="0.8"></line>
                            <line x1="12" y1="-1.38777878e-16" x2="12" y2="4.5" id="Path-17-Copy" strokeOpacity="0.8"></line>
                            <line x1="3.5" y1="8.5" x2="12.5" y2="8.5" id="Path-18" strokeOpacity="0.920618444"></line>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
